import { searchPeople } from "./mobile-search.js";
export function pathNotice(result, name) {
  if (!result?.ids.length) return '';
  if (result.ids.length === 1) return 'Choisissez une deuxième personne pour chercher un chemin.';
  const missing = result.pairs.filter(pair => pair.distance === null);
  if (!missing.length) return '';
  const pairs = missing.map(pair => `${name(pair.a)} ↔ ${name(pair.b)}`).join(' ; ');
  const found = result.pairs.length - missing.length;
  return `${found ? `${found} paire reliée sur ${result.pairs.length}. ` : ''}Aucun chemin documenté dans le réseau collecté : ${pairs}. Cela ne prouve pas une absence de relation.`;
}
export function installPathSearch(getPeople, onChange, onFit) {
  const dialog = document.querySelector("#pathDialog"), input = document.querySelector("#pathPersonSearch");
  const list = document.querySelector("#pathResults"), selected = document.querySelector("#pathSelected");
  const feedback = document.querySelector("#pathFeedback"), summary = document.querySelector("#pathSummary");
  const triggers = [...document.querySelectorAll(".path-trigger")];
  let ids = [], result = null, opener;
  const names = new Map();
  const name = id => names.get(id) || id;
  function updateNotice() {
    getPeople().forEach(person => names.set(person.id, person.name));
    const text = pathNotice(result, name), notice = document.querySelector('#pathNotice');
    notice.hidden = !text;
    const paragraph = document.querySelector('#pathNoticeText');
    if (paragraph.textContent !== text) paragraph.textContent = text;
    const empty = result?.pairs.length && result.pairs.every(pair => pair.distance === null);
    document.querySelector('#showPaths').textContent = empty ? 'Voir les personnes' : 'Voir les chemins';
  }
  function refresh() {
    const focusedPerson = document.activeElement?.dataset.person;
    const focusedRemove = document.activeElement?.dataset.remove;
    const people = getPeople(); people.forEach(p => names.set(p.id, p.name));
    selected.replaceChildren();
    ids.forEach((id, index) => {
      const li = document.createElement("li"), button = document.createElement("button");
      button.type = "button"; button.dataset.remove = id; button.textContent = `${String.fromCharCode(65 + index)} · ${name(id)} ×`;
      button.setAttribute("aria-label", `Retirer ${name(id)}`);
      button.addEventListener("click", () => { setIds(ids.filter(v => v !== id)); input.focus(); });
      li.append(button); selected.append(li);
    });
    input.disabled = ids.length === 3;
    const matches = input.disabled ? [] : searchPeople(people.filter(p => !ids.includes(p.id)), input.value);
    list.replaceChildren();
    for (const person of matches) {
      const li = document.createElement("li"), button = document.createElement("button");
      button.type = "button"; button.dataset.person = person.id;
      button.textContent = `${person.name}${person.birthYear != null ? ` · né·e en ${person.birthYear}` : ""} · ${person.id}`;
      button.addEventListener("click", () => { input.value = ""; setIds([...ids, person.id]);
        (input.disabled ? document.querySelector("#showPaths") : input).focus(); });
      li.append(button); list.append(li);
    }
    feedback.textContent = ids.length === 3 ? "3 personnes sélectionnées. Retirez un nom pour le remplacer."
      : input.value.trim() && !matches.length ? "Aucune autre personne trouvée dans le réseau collecté."
      : ids.length === 2 ? "Ajoutez un troisième nom, ou affichez les chemins." : `Choisissez ${ids.length ? "encore 1 ou 2 noms" : "2 ou 3 noms"}.`;
    summary.replaceChildren();
    for (const pair of result?.pairs || []) {
      const li = document.createElement("li"), swatch = document.createElement("i");
      swatch.style.backgroundColor = pair.color; swatch.setAttribute("aria-hidden", "true");
      li.append(swatch, `${name(pair.a)} ↔ ${name(pair.b)} : ${pair.distance === null ? "aucun chemin connu" : `${pair.distance} lien${pair.distance > 1 ? "s" : ""}`}`);
      summary.append(li);
    }
    for (const id of ids.filter(id => !people.some(p => p.id === id))) {
      const li = document.createElement("li"); li.textContent = `${name(id)} : personne absente du réseau actuel.`; summary.append(li);
    }
    triggers.forEach(t => { t.classList.toggle("is-active", ids.length > 0); t.setAttribute("aria-pressed", String(ids.length > 0)); });
    document.querySelector("#showPaths").disabled = ids.length < 2;
    document.querySelector("#clearPaths").hidden = !ids.length;
    if (focusedPerson) [...list.querySelectorAll("button")].find(b => b.dataset.person === focusedPerson)?.focus({ preventScroll: true });
    if (focusedRemove) [...selected.querySelectorAll("button")].find(b => b.dataset.remove === focusedRemove)?.focus({ preventScroll: true });
  }
  function setIds(next) { ids = [...new Set(next)].slice(0, 3); onChange(ids); refresh(); }
  triggers.forEach(t => t.addEventListener("click", () => {
    opener = t; input.value = ""; refresh(); dialog.showModal(); t.setAttribute("aria-expanded", "true");
    (input.disabled ? document.querySelector("#showPaths") : input).focus();
  }));
  document.querySelector("#closePaths").addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => { input.blur(); triggers.forEach(t => t.setAttribute("aria-expanded", "false")); opener?.focus(); });
  document.querySelector("#clearPaths").addEventListener("click", () => { input.value = ""; setIds([]); dialog.close(); });
  document.querySelector('#editPathNotice').addEventListener('click', () => {
    document.querySelector('#closeInspector').click();
    (triggers.find(button => button.getBoundingClientRect().width > 0) || triggers[0])?.click();
  });
  document.querySelector('#exitPathNotice').addEventListener('click', () => { input.value = ''; setIds([]); });
  document.querySelector("#showPaths").addEventListener("click", () => { input.blur(); dialog.close(); onFit(); });
  input.addEventListener("input", refresh);
  input.addEventListener("keydown", event => {
    if (!event.isComposing && ["Enter", "ArrowDown"].includes(event.key)) { event.preventDefault(); list.querySelector("button")?.focus(); }
  });
  document.addEventListener("entourages:people-updated", () => { if (dialog.open && !list.contains(document.activeElement)) refresh(); });
  return { setIds, update(next) { result = next; updateNotice(); if (dialog.open) refresh(); } };
}
